import { gql } from "@apollo/client";

// ============================================================================
// JOB QUERIES
// ============================================================================

import {
  GENERAL_FIELDS,
  SITE_FIELDS,
  PAGE_SETTINGS,
  BUTTON_RECORD,
  DOWNLOAD_BUTTON_RECORD,
  HUBSPOT_BUTTON_RECORD,
  OFFICE_LOCATION,
} from "./shared";
import { OFFICE_FIELDS } from "./offices";
import { SECTIONS_WRAPPER_QUERY } from "./fragments/sections";

export const CAREER_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${PAGE_SETTINGS}
  ${BUTTON_RECORD}
  ${HUBSPOT_BUTTON_RECORD}
  ${SECTIONS_WRAPPER_QUERY}
  query GetCareerData($locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: career(locale: $locale) {
      # Career Meta (SEO)
      _locales
      titles: _allTitleLocales(locale: $locale) {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      blockSearchIndexing
      __typename

      # Career Fields (Content)
      id
      title
      shortTitle
      intro {
        value
      }
      introButton {
        ...ButtonBlock
        ...HubspotButtonBlock
      }

      # Career Intro Image
      introImage {
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "1560", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }
      introImageMobile: introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "525", h: "375", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }

      # Career Components
      sections {
        ...SectionWrapperQuery
      }
      pageSettings {
        ...PageSettings
      }
    }
  }
`;

export const JOBS_OVERVIEW_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${OFFICE_FIELDS}
  ${OFFICE_LOCATION}
  ${BUTTON_RECORD}
  ${DOWNLOAD_BUTTON_RECORD}
  ${HUBSPOT_BUTTON_RECORD}
  query GetJobs($locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    overview: career {
      # Career Meta (SEO)
      titles: _allTitleLocales(locale: $locale) {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      blockSearchIndexing
      __typename
    }
    fields: jobListingOverview(locale: $locale) {
      _locales
      # Jobs Overview Meta (SEO)
      titles: _allTitleLocales(locale: $locale) {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      blockSearchIndexing

      # Jobs Overview Fields (Content)
      title
      shortTitle
      intro {
        value
      }
      introButton {
        ...ButtonBlock
        ...DownloadButtonBlock
        ...HubspotButtonBlock
      }

      # Jobs Overview Intro Image
      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "1560", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }
    }
    offices: allOffices(
      first: 100
      filter: {
        parent: { exists: "false" }
        blockSearchIndexing: { eq: "false" }
        _locales: { allIn: [$locale] }
        hideOfficeFromOverview: { eq: false }
      }
    ) {
      ...OfficeFields
      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "500", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }
      officeLocations {
        ...OfficeLocation
      }
    }
  }
`;

export const JOB_TEMPLATE_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${SECTIONS_WRAPPER_QUERY}
  query GetJobTemplate($locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    overview: career {
      # Career Meta (SEO)
      titles: _allTitleLocales(locale: $locale) {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      blockSearchIndexing
      __typename
    }
    fields: jobListingLayout(locale: $locale) {
      id
      sections {
        ...SectionWrapperQuery
      }
    }
  }
`;
